const routes = {
  index: {
    path: 'index.consult.railway',
    url: '/voie',
  },
  home: {
    path: 'index.consult.railway.home',
    url: '/accueil',
  },
  new: {
    path: 'index.consult.railway.new',
    url: '/creer',
  },
  edit: {
    path: 'index.consult.railway.edit',
    url: '/modifier',
  },
  details: {
    path: 'index.consult.railway.details',
    url: '/details',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/railway/routes.js